var _excluded = ["event_id", "logger_id", "user_id", "index"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @file 发送展示统计
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/scroll
 */

/* eslint-disable camelcase */
import request from './util/request';
import throttle from './util/throttle';
import configurable from './util/configurable';
import { parse, camelToUnder } from './util/json';
import { on, off, isInViewPort } from './util/dom';
import { trackID, userID, Config } from './util/config';
import warnForbiddenKeys from './util/forbiddenWords';
import metric from './metric';
/**
 * 屏蔽点击上报的标记属性名
 *
 * @const {string}
 */

var NO_LOG_FLAG = 'data-habo-noscroll';
/**
 * 监听滚动上报的 CSS class
 *
 * @const {string}
 */

var SCROLL_CLASS = '.habo-scroll-observe';
/**
 * 收集点击上报所必需参数的属性名
 *
 * @const {string}
 */

var LOG_FLAG_N_PARAMS = 'data-habo-params';
/**
 * 滚动可见后事件上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */

var report = configurable(function (json, callback) {
  var _camelToUnder = camelToUnder(json),
      _camelToUnder$event_i = _camelToUnder.event_id,
      event_id = _camelToUnder$event_i === void 0 ? '' : _camelToUnder$event_i,
      logger_id = _camelToUnder.logger_id,
      _camelToUnder$user_id = _camelToUnder.user_id,
      user_id = _camelToUnder$user_id === void 0 ? userID : _camelToUnder$user_id,
      index = _camelToUnder.index,
      rest = _objectWithoutProperties(_camelToUnder, _excluded); // 处理多个 event id 的情况，第一个为点击事件的 id，第二个为滚动事件的 id


  var _String$split = String(event_id).split(','),
      _String$split2 = _slicedToArray(_String$split, 2),
      clickEventID = _String$split2[0],
      _String$split2$ = _String$split2[1],
      scrollEventID = _String$split2$ === void 0 ? clickEventID : _String$split2$; // 上报数据


  var scrollLogData = _objectSpread({
    // 当前页面，与 PV 上报字段名保持一致
    page_url: location.href,
    // 事件 id
    event_id: scrollEventID,
    // 对应的后端日志 id
    logger_id: logger_id,
    // 登录用户 id
    user_id: user_id,
    // 对于列表项中的展示 ，需要该字段区分是第几个列表项，从 0 开始
    index: index,
    // 用户的唯一标识，由后端生成写到 cookie 中
    track_id: trackID
  }, rest);

  warnForbiddenKeys(scrollLogData);
  request(Config.VERB)("".concat(Config.GS), scrollLogData, callback); // 自动上报点击指标数据到轻舟

  metric(_objectSpread(_objectSpread({}, scrollLogData), {}, {
    metric: 'scroll'
  }));
}, {});
/**
 * 滚动事件处理
 *
 * @function
 */

var observe = throttle(function (event) {
  var elements = document.querySelectorAll(SCROLL_CLASS); // 低级浏览器 的 HTMLCollection 不支持 forEach

  [].forEach.call(elements, function (el) {
    // 最外层的滚动事件的event.target在chrome里是window，在ie里是document，都没有contains方法
    var isDescendant = event.target === window || event.target === document || event.target.contains(el);

    if (!el.hasAttribute(NO_LOG_FLAG) && isInViewPort(el) && isDescendant) {
      report(parse(el.getAttribute(LOG_FLAG_N_PARAMS)));
      el.setAttribute(NO_LOG_FLAG, '');
    }
  });
}, 50);

report.trigger = function (el) {
  return observe({
    target: el || window
  });
};

var win = typeof window !== 'undefined' && window;
/**
 * 解除相关事件的绑定
 */

var destroy = function destroy() {
  off(win, 'scroll', observe, true);
  off(win, 'unload', destroy);
};

on(win, 'scroll', observe, true);
on(win, 'unload', destroy);
export default report;